import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 w-10/12" }
const _hoisted_2 = { class: "p-6 rounded-xl border border-gray-lp-1300 flex flex-col" }
const _hoisted_3 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M9 12C9 12.55 9.45 13 10 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11H10C9.45 11 9 11.45 9 12Z",
    fill: "#A7A8AA"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0002 3H7.00018C6.69018 3 6.39019 3.15 6.20019 3.4L3.20019 7.4C3.19368 7.40918 3.18733 7.41843 3.18113 7.42776C3.06709 7.59016 3 7.78763 3 8V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V8C21 7.93796 20.9943 7.8772 20.9833 7.81821C20.9568 7.66842 20.8958 7.52471 20.8002 7.4L17.8002 3.4C17.6102 3.15 17.3102 3 17.0002 3ZM18.0002 7L16.5002 5H13V7H18.0002ZM11 7V5H7.50018L6.00018 7H11ZM5 9H19V19H5V9Z",
    fill: "#A7A8AA"
  })
], -1)
const _hoisted_5 = { class: "flex my-6 flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "mb-8 mt-4"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_8 = {
  key: 2,
  class: "mb-8 mt-4"
}
const _hoisted_9 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", { class: "mb-8 mt-4" }, null, -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = {
  key: 0,
  class: "py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, " Jenis pengiriman tidak tersedia karena terjadi embargo. ", -1)
const _hoisted_15 = { class: "mt-8" }
const _hoisted_16 = {
  key: 1,
  class: "py-2 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_18 = { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }
const _hoisted_19 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_20 = { class: "flex items-center justify-center py-3" }
const _hoisted_21 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_22 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionFilterClient = _resolveComponent("SectionFilterClient")!
  const _component_SectionSTTManualReference = _resolveComponent("SectionSTTManualReference")!
  const _component_SectionSenderDetail = _resolveComponent("SectionSenderDetail")!
  const _component_SectionRecipientDetail = _resolveComponent("SectionRecipientDetail")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_SectionPackageDetail = _resolveComponent("SectionPackageDetail")!
  const _component_SectionFTZ = _resolveComponent("SectionFTZ")!
  const _component_SectionAdditionalInfoInterpack = _resolveComponent("SectionAdditionalInfoInterpack")!
  const _component_SectionGoodsWeight = _resolveComponent("SectionGoodsWeight")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_SectionProductUpselling = _resolveComponent("SectionProductUpselling")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card = _resolveComponent("card")!
  const _component_DialogPayment = _resolveComponent("DialogPayment")!
  const _component_SectionFooterBooking = _resolveComponent("SectionFooterBooking")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.title,
      "vertical-separator": false,
      fullPage: ""
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.formType === 'client')
            ? (_openBlock(), _createBlock(_component_SectionFilterClient, {
                key: 0,
                modelValue: _ctx.manualBooking,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.manualBooking = $event)),
                onGetClientStatus: _ctx.onGetClientStatus,
                isErrorClient: _ctx.isErrorClient,
                errorMandatory: _ctx.error.errorMandatoryClientColumn
              }, null, 8, ["modelValue", "onGetClientStatus", "isErrorClient", "errorMandatory"]))
            : _createCommentVNode("", true),
          _createVNode(_component_SectionSTTManualReference, {
            ref: "sttManualReference",
            modelValue: _ctx.manualBooking,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.manualBooking = $event)),
            error: _ctx.error,
            "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_ctx.error = $event)),
            formType: _ctx.formType,
            isClientDO: _ctx.isClientDO,
            isDO: _ctx.isDO
          }, null, 8, ["modelValue", "error", "formType", "isClientDO", "isDO"]),
          _createVNode(_component_SectionSenderDetail, {
            ref: "senderDetail",
            onLoadUpsellingOrigin: _ctx.loadUpsellingProduct,
            modelValue: _ctx.manualBooking,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualBooking = $event)),
            error: _ctx.error,
            accountIsNonForeign: _ctx.accountIsNonForeign,
            onGetWoodPacking: _ctx.getWoodPacking,
            onGetDocumentInternational: _ctx.getDocumentInternational,
            onAutofillCommodity: _ctx.autofillCommodity,
            onAutofillCommodityNotFound: _ctx.autofillCommodityNotFound,
            detailClientManagement: _ctx.detailClientManagement,
            formType: _ctx.formType
          }, null, 8, ["onLoadUpsellingOrigin", "modelValue", "error", "accountIsNonForeign", "onGetWoodPacking", "onGetDocumentInternational", "onAutofillCommodity", "onAutofillCommodityNotFound", "detailClientManagement", "formType"]),
          _createVNode(_component_SectionRecipientDetail, {
            ref: "recipientDetail",
            modelValue: _ctx.manualBooking,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.manualBooking = $event)),
            error: _ctx.error,
            accountIsNonForeign: _ctx.accountIsNonForeign,
            listKGs: _ctx.listKGs,
            disableSaveReceiver: _ctx.disableSaveReceiver,
            postalCodeDestinationOptions: _ctx.postalCodeDestinationOptions,
            onOnSearchZipCode: _ctx.setPostalCode,
            onOnChangeDistrict: _ctx.onSelectDestination,
            detailClientManagement: _ctx.detailClientManagement,
            formType: _ctx.formType
          }, null, 8, ["modelValue", "error", "accountIsNonForeign", "listKGs", "disableSaveReceiver", "postalCodeDestinationOptions", "onOnSearchZipCode", "onOnChangeDistrict", "detailClientManagement", "formType"]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Title, {
                fontColor: "text-black",
                fontSize: 20,
                label: _ctx.$t('revamp.booking.detailPackageAndServiceType')
              }, null, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_SectionPackageDetail, {
                ref: "packageDetail",
                modelValue: _ctx.manualBooking,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.manualBooking = $event)),
                errorEmbargo: _ctx.errorEmbargo,
                errorEstimationPrice: _ctx.errorEstimationPrice,
                "onUpdate:errorEstimationPrice": _cache[8] || (_cache[8] = ($event: any) => (_ctx.errorEstimationPrice = $event)),
                formType: _ctx.formType,
                onOnChangeCommodities: _ctx.onChangeCommodities,
                onOnChangeDeliveryFeeType: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeDeliveryFeeType(this))),
                isCodAmount: 
                _ctx.dataProfile.account_type === 'client'
                  ? _ctx.formType === 'manual'
                  : _ctx.formType === 'client' &&
                    _ctx.manualBooking.clientName?.clientCodConfigAmountData?.includes(
                      'goods_price'
                    )
              
              }, {
                woodpacking: _withCtx(() => [
                  _createVNode(_component_Woodpacking, {
                    ref: "woodpacking",
                    modelValue: _ctx.manualBooking.isWoodpack,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.manualBooking.isWoodpack = $event)),
                    city: _ctx.cityForWoodPacking,
                    version: "v2",
                    eligibleAccess: _ctx.eligibleToWoodpacking
                  }, null, 8, ["modelValue", "city", "eligibleAccess"])
                ]),
                _: 1
              }, 8, ["modelValue", "errorEmbargo", "errorEstimationPrice", "formType", "onOnChangeCommodities", "isCodAmount"])
            ]),
            (_ctx.isFtzAccount)
              ? (_openBlock(), _createBlock("hr", _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.isFtzAccount)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_SectionFTZ, {
                    modelValue: _ctx.manualBooking,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.manualBooking = $event)),
                    error: _ctx.error,
                    "onUpdate:error": _cache[11] || (_cache[11] = ($event: any) => (_ctx.error = $event)),
                    formType: _ctx.formType
                  }, null, 8, ["modelValue", "error", "formType"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.eligibleAdditionalInfo)
              ? (_openBlock(), _createBlock("hr", _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.eligibleAdditionalInfo)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode(_component_SectionAdditionalInfoInterpack, {
                    ref: "getdocinternational",
                    modelValue: _ctx.additionalInfo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.additionalInfo = $event)),
                    error: _ctx.errAditionalInfo,
                    "onUpdate:error": _cache[13] || (_cache[13] = ($event: any) => (_ctx.errAditionalInfo = $event)),
                    indexErrorCommodity: "20",
                    indexErrorEmail: "20.5",
                    indexErrorSttIdentityNumber: "21",
                    indexErrorSttInterTaxNumber: "21.5",
                    originCity: _ctx.origin.cityId || _ctx.manualBooking.originCity.cityId,
                    destinationCity: _ctx.manualBooking.destinationCity.cityId,
                    onSetFieldIndex: _ctx.setFieldIndex,
                    errorCommodity: _ctx.errorMandatory[20],
                    errorEmail: _ctx.errorMandatory[21],
                    errorSttIdentityNumber: _ctx.errorMandatory[23],
                    errorSttInterTaxNumber: _ctx.errorMandatory[24],
                    productName: _ctx.manualBooking.productName
                  }, null, 8, ["modelValue", "error", "originCity", "destinationCity", "onSetFieldIndex", "errorCommodity", "errorEmail", "errorSttIdentityNumber", "errorSttInterTaxNumber", "productName"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_SectionGoodsWeight, {
              ref: "goodsWeight",
              modelValue: _ctx.manualBooking,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.manualBooking = $event)),
              listKGsProp: _ctx.listKGs,
              "onUpdate:listKGsProp": _cache[15] || (_cache[15] = ($event: any) => (_ctx.listKGs = $event)),
              showWarningHwsProp: _ctx.showWarningHws,
              "onUpdate:showWarningHwsProp": _cache[16] || (_cache[16] = ($event: any) => (_ctx.showWarningHws = $event)),
              isMaxAddKgs: _ctx.isMaxAddKgs,
              isErrorHws: _ctx.isErrorHws,
              errorEmbargo: _ctx.errorEmbargo,
              onOnUpdateEmbargoStatusFail: _ctx.onUpdateEmbargoStatusFail,
              onSetFieldIndex: _ctx.setFieldIndex,
              onOnSetErrorHws: _ctx.onSetErrorHws,
              onUpdateTotalChargeableWeight: _ctx.updateTotalChargeableWeight,
              onUpdateTotalGrossWeight: _ctx.updateTotalGrossWeight,
              onUpdateTotalVolumeWeight: _ctx.updateTotalVolumeWeight,
              productConfigurationRuleListProp: 
              _ctx.productConfigurationRuleList
            ,
              "onUpdate:productConfigurationRuleListProp": _cache[17] || (_cache[17] = ($event: any) => (
              _ctx.productConfigurationRuleList
             = $event)),
              onUpdateTotalCampaignChargeableWeight: 
              _ctx.updateTotalCampaignChargeableWeight
            ,
              isCampaign: _ctx.isCampaign,
              formType: _ctx.formType
            }, null, 8, ["modelValue", "listKGsProp", "showWarningHwsProp", "isMaxAddKgs", "isErrorHws", "errorEmbargo", "onOnUpdateEmbargoStatusFail", "onSetFieldIndex", "onOnSetErrorHws", "onUpdateTotalChargeableWeight", "onUpdateTotalGrossWeight", "onUpdateTotalVolumeWeight", "productConfigurationRuleListProp", "onUpdateTotalCampaignChargeableWeight", "isCampaign", "formType"]),
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_SectionProductUpselling, { formType: _ctx.formType }, {
                product: _withCtx(() => [
                  (_ctx.isEmbargo)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _hoisted_14
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_product_poster, {
                      ref: "renderPoster",
                      onChoseeProduct: _ctx.onSelectProduct,
                      onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
                      isOnePack: _ctx.isOnePack,
                      isFormForeign: !_ctx.accountIsNonForeign,
                      version: "v2",
                      isEmbargo: _ctx.isEmbargo,
                      hideKgs: _ctx.hideKgs,
                      "booking-type": _ctx.formType,
                      onSetLoadingUpselling: _ctx.setLoadingUpselling
                    }, null, 8, ["onChoseeProduct", "onSetErrorTriggered", "isOnePack", "isFormForeign", "isEmbargo", "hideKgs", "booking-type", "onSetLoadingUpselling"])
                  ]),
                  (_ctx.isShowWarningSla)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("p", _hoisted_18, " Informasi penting! Sampaikan ke customer Anda bahwa rute yang dipilih estimasi pengirimannnya " + _toDisplayString(_ctx.estimateSla.slaMin) + " - " + _toDisplayString(_ctx.estimateSla.slaMax) + " hari kerja. ", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["formType"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.titleErrorspesification,
      message: _ctx.errorCause,
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
    ]),
    (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.booking,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin Keluar Halaman?'),
      message: 
      _ctx.$t(
        'Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.'
      )
    ,
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('bookingShipment.action.buttonQuit'),
      textCancel: _ctx.$t('bookingShipment.action.buttonStay'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('Pembuatan Booking Baru Berhasil !'),
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode("h2", _hoisted_19, _toDisplayString(this.$t("bookingShipment.error.totalPayment")), 1),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalBeforeDiscount)), 1),
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _createVNode(_component_DialogPayment, {
      onSuccessPayment: _ctx.onCloseSuccess,
      billType: "booking",
      textHeader: "Pembuatan Booking Berhasil"
    }, null, 8, ["onSuccessPayment"]),
    (_ctx.renderDetailCalculation)
      ? _withDirectives((_openBlock(), _createBlock(_component_SectionFooterBooking, {
          key: 1,
          isDisabled: _ctx.getIsDisableButton,
          payload: _ctx.payload,
          accountRefAndCommodity: _ctx.accountRefAndCommodity,
          formType: _ctx.formType,
          isCodRetailApplied: _ctx.isCodRetailApplied,
          isVolumeWeight: _ctx.isVolumeWeight,
          isGrossWeight: _ctx.isGrossWeight,
          totalItem: _ctx.listKGs.length,
          totalGrossWeight: _ctx.totalGrossWeight,
          totalDimensionWeight: _ctx.totalVolumeWeight,
          chargeableWeight: 
      _ctx.isCampaign
        ? _ctx.totalCampaignChargeableWeight.toString().replace('.', ',')
        : _ctx.totalChargeableWeight
    ,
          onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo,
          onSetDiscount: _ctx.setDiscount,
          isCampaign: _ctx.isCampaign,
          goodsValue: _ctx.manualBooking.estimationPrice
        }, null, 8, ["isDisabled", "payload", "accountRefAndCommodity", "formType", "isCodRetailApplied", "isVolumeWeight", "isGrossWeight", "totalItem", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "onUpdateStatusErrorEmbargo", "onSetDiscount", "isCampaign", "goodsValue"])), [
          [_vShow, !_ctx.isLoading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}